import { useOutletContext } from "react-router-dom";
import ClientHome from "@/pages/app/ClientHome";
import DietitianHome from "@/pages/app/DietitianHome";

export default function AppHome() {
  const { me } = useOutletContext();
  const role = me?.user?.role;
  if (role === "client") return <ClientHome />;
  // dietitian, owner, admin all see the clients list as home
  return <DietitianHome />;
}
